/**
 * The issue table's built-in columns. These match the `name` of the
 * DynamicColumn rows seeded for the Issues module config, and the order here
 * is the order the table renders them in.
 */
export const IssueTableColumn = {
  DATE: 'date',
  REG_NR: 'regNr',
  REFERENCE: 'reference',
  EMPLOYEE: 'employee',
  CATEGORY: 'category',
  RISK_ASPECT: 'riskAspect',
  SEVERITY: 'severity',
  STATUS: 'status',

  // Offered in settings, off until a company turns them on. Names match the
  // DynamicColumn rows seeded by dynamic_tables migration 0021.
  TITLE: 'title',
  TAGS: 'tags',
  RESPONSIBLE_USER: 'responsibleUser',
  CASE_HANDLER: 'caseHandler',
  PROCESS: 'process',
  SUBCATEGORY: 'subcategory',
  LOCATION: 'location',
  CREATED_AT: 'createdAt',
  DATE_END: 'dateEnd',
  COST_ESTIMATION: 'costEstimation',
  ACTUAL_COST: 'actualCost',
  CLOSED_AT: 'closedAt',
} as const

export type IssueTableColumnValue =
  (typeof IssueTableColumn)[keyof typeof IssueTableColumn]

/** A company-defined relation shown as its own column. */
export interface IssueTableRelationColumn {
  id: string
  name: string
}
